const ServicesDetail = [
    {
        id:"1",
        Image:"./Services-Images/Wallet.png",
        heading:"Toda oferta em dinheiro",
        info:"Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem."
    },
    {
        id:"2",
        Image:"./Services-Images/piggy-bank.png",
        heading:"Sem adiantamento",
        info:"Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem."
    },
    {
        id:"3",
        Image:"./Services-Images/document.png",
        heading:"Especialistas ao seu lado",
        info:"Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem."
    },
    {
        id:"4",
        Image:"./Services-Images/unlock.png",
        heading:"Bloqueado no preço",
        info:"Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem."
    },
]
export default ServicesDetail